import styled, { css } from 'styled-components'

import { AlertType } from './alert.types'

export const Container = styled.div<{ $type: AlertType }>(({ theme, $type }) => {
  const styles = {
    error: css`
      color: ${theme.colors.red500};
      background-color: ${theme.colors.red100};

      & > button:last-child {
        color: ${theme.colors.red600};
      }
    `,
    info: css`
      color: ${theme.colors.blue600};
      background-color: ${theme.colors.blue100};

      & > button:last-child {
        color: ${theme.colors.blue600};
      }
    `,
    success: css`
      color: ${theme.colors.green500};
      background-color: ${theme.colors.green100};

      & > button:last-child {
        color: ${theme.colors.green600};
      }
    `,
  }

  return css`
    position: relative;
    display: flex;
    align-items: flex-start;
    align-self: flex-start;
    gap: ${theme.space['8']};
    padding: ${theme.space['12']} ${theme.space['16']};
    border-radius: ${theme.border.radius['8']};
    word-break: break-word;

    ${styles[$type]}

    > button:last-child {
      margin-left: auto;
    }
  `
})

export const ContentWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['4']};
    justify-content: center;
    height: 100%;
  `,
)

export const Title = styled.p`
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 2.4rem;
`

export const Message = styled.p`
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2rem;
`
